import { createFileRoute } from "@tanstack/react-router";

import { OrdersPage } from "@/components/Pages/Orders";

export const Route = createFileRoute("/_guard/orders/")({
  component: OrdersPage,
});
